
$(document).ready(function () {
    //footer mobile
    $('.footer-col-header').on('click', function () {
        if ($(window).width() < 768) {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open').next('ul').slideUp(200);
            } else {
                $(this).closest('footer').find('.open').removeClass('open').next('ul').slideUp(200);
                $(this).addClass('open').next('ul').slideDown(200);
            }
        }
    });
    
    $('.wrap_content').on('click', '.fav-more-btn', function() {
        $(this).siblings('.control-modal').fadeToggle(0);

        $(document).on('mouseup', function (e) {
            var $target = $(".control-modal");
            if ($target.has(e.target).length === 0) {
                $target.fadeOut(0);
            }
        });
    });

    // y-scroll
    if($(window).width() > 1024) {
        $('.custom_scrollbar_y:not(.custom_scrollbar_y--filter)').mCustomScrollbar({
            theme: "minimal-dark",
        });
    }

    // read more
    if($('.read-more').prev('div').find('p').height() <= 48){
        $('.read-more').hide();
    } else {
        $('.read-more').show();
    }
    $('.read-more').on('click', function() {
        if($(this).hasClass('showed')) {
            $(this).removeClass('showed');
            $(this).prev('div').css('height', '48px');
        } else {
            $(this).addClass('showed');
            $(this).prev('div').css('height', $(this).prev('div').find('p').height());
        }
    });

    // Info block
    if(!$('.article-page').length) {
        $(document).on('mouseenter touchstart', '.info-btn', function() {
            var infoBlock = $(this).find('p');
            $(this).addClass('open');

            if(($(this).offset().left + 200) > $(window).width()) {
                infoBlock.css({
                    left: 'auto',
                    right : '-24px'
                });
            } else {
                infoBlock.css({
                    right: 'auto',
                    left : '-33px'
                });
            }
        })
        .on('mouseleave touchend', '.info-btn', function() {
            $(this).removeClass('open');
        });
    } else {
        $(document).on('click', '.info-btn', function() {
            var infoBlock = $(this).closest('.content-row').find('.row-help');
            infoBlock.addClass('open');

            if (window.innerWidth > 767) {
                if(($(this).offset().left + 200) > $(window).width()) {
                    infoBlock.css({
                        left: 'auto',
                        right : '0'
                    });
                } else {
                    infoBlock.css({
                        right: 'auto',
                        left : '-46px'
                    });
                }
            }
        });

        $(document).on('mouseup', function (e) {
            var container = $(".info-btn");
            if (container.has(e.target).length === 0) {
                $('.row-help').removeClass('open');
            }
        });
        $('.row-help').on('click', '.close', function(e) {
            $(this).closest('.row-help').removeClass('open');
        });
    }
    
    // accordion/tabs in account page
    $(window).on('resize orientationchange', function () {
        if($(window).width() > 991 && $('.account-page').length) {
            var currentTab = $('.tab_controls').find('.active').attr('data-id');
            $('.tab_area').find('#' + currentTab).fadeIn(200);
            $('.tab_area').find('#' + currentTab).prev('.tab_header').addClass('open');
        }
    });

    //sort select
    $('.wrap_content').on('click', '.sort-select', function() {
        $(this).toggleClass('open');
    });

    $('.wrap_content').on('click', '.sort-select li', function() {
        $(this).closest('ul').find('.active').removeClass('active');
        $(this).addClass('active');
    });
    $(document).mouseup(function(e) {
        var container = $(".sort-select");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            container.removeClass('open');
        }
    });
    
    //Timer
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

    $('.timer').each(function() {
        var $this = $(this);
        let countDown = new Date($(this).attr('data-time')).getTime(),
        x = setInterval(function() { 
            let now = new Date().getTime(),
                distance = countDown - now;
  
            if(Math.floor(distance / (day)) < 10) {
                $this.find('#days').html('0' + Math.floor(distance / (day)));
            } else {
                $this.find('#days').html( Math.floor(distance / (day)));
            }
            if(Math.floor((distance % (day)) / (hour)) < 10) {
                $this.find('#hours').html('0' + Math.floor((distance % (day)) / (hour)));
            } else {
                $this.find('#hours').html(Math.floor((distance % (day)) / (hour)));
            }
            if(Math.floor((distance % (hour)) / (minute)) < 10) {
                $this.find('#minutes').html('0' + Math.floor((distance % (hour)) / (minute)));
            } else {
                $this.find('#minutes').html(Math.floor((distance % (hour)) / (minute)));
            }
            if(Math.floor((distance % (minute)) / second) < 10) {
                $this.find('#seconds').html('0' + Math.floor((distance % (minute)) / second));
            } else {
                $this.find('#seconds').html(Math.floor((distance % (minute)) / second));
            }

            if(Math.floor(distance / (day)) == 0 && Math.floor((distance % (day)) / (hour)) == 0 && Math.floor((distance % (hour)) / (minute)) == 0 && Math.floor((distance % (minute)) / second) == 0) {
                clearInterval(x)
            }

            if(distance < 0) {
                $this.find('#days').html('00');
                $this.find('#hours').html('00');
                $this.find('#minutes').html('00');
                $this.find('#seconds').html('00');
            }
        }, second);
    });

    // info cloud block
    $('.wrap_page').on('click', '.info-clouds__block .close', function() {
        $(this).closest('.info-cloud').slideUp(100, function() {
            $(this).remove();
        });
    });

    // service open
    $('.wrap_page').on('click', '.service-open', function() {
        if(!$(this).closest('.service-block').hasClass('open')) {
            $(this).closest('form').find('.service-block.open').each(function() {
                $(this).removeClass('open');
                $(this).find('.service-block--bottom').slideUp(0);
                $(this).next('.service-btn').slideUp(0);
            })
            $(this).siblings('.service-block--bottom').slideDown(0).css('display', 'flex');
            $(this).closest('.service-block').next('.service-btn').slideDown(0, function(){
                $(this).css('display', 'inline-flex');
            });
            $(this).closest('.service-block').addClass('open');
        }
    });
    
    //Fixed tables
    $('body').find('table').each(function() {
        $(this).wrap('<div class="table-block"></div>');
    });

    // dotdotdot
    $('.chat-item__text').dotdotdot({
        ellipsis: '...',
        wrap: 'letter',
        // height: '32px'
    });

    // accordion
    $('.wrap_container').on('click', '.accordion-header', function(e) {
        e.preventDefault();

        if($(this).hasClass('open')) {
            if($(this).closest('.sites-item').length) {
                $(this).closest('.sites-item').next('.accordion-body').slideUp(200);
            } else {
                $(this).next('.accordion-body').slideUp(200);
            }
            $(this).removeClass('open');
            if($(this).closest('.accordion-wrap').find('.accordion-header.open').closest('.sites-item').length) {
                $(this).closest('.accordion-wrap').find('.accordion-header.open').closest('.sites-item').next('.accordion-body').stop().slideUp(200);
            } else {
                $(this).closest('.accordion-wrap').find('.accordion-header.open').next('.accordion-body').stop().slideUp(200);
            }
            $(this).closest('.accordion-wrap').find('.accordion-header.open').removeClass('open');
        } else {
            if($(this).closest('.accordion-wrap').find('.accordion-header.open').closest('.sites-item').length) {
                $(this).closest('.accordion-wrap').find('.accordion-header.open').closest('.sites-item').next('.accordion-body').stop().slideUp(200);
            } else {
                $(this).closest('.accordion-wrap').find('.accordion-header.open').next('.accordion-body').stop().slideUp(200);
            }
            $(this).closest('.accordion-wrap').find('.accordion-header.open').removeClass('open');
            if($(this).closest('.sites-item').length) {
                $(this).closest('.sites-item').next('.accordion-body').slideDown(200);
            } else {
                $(this).next('.accordion-body').slideDown(200);
            }
            $(this).addClass('open');
        }
    });

    // format show more
    $('.my-sites-page').on('click', '.format-show-more', function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).next('.format-more-block').slideToggle(100);
    });

    // user block (header)
    $('.user-link').on('click', function() {
        $(this).next('.header_user_block').fadeToggle(100);
    });
    $(document).on('mouseup', function (e) {
        var container = $(".header_user_block");
        if (container.has(e.target).length === 0 && $('.user-link').has(e.target).length === 0 && !container.is(e.target)) {
            container.fadeOut(100);
        }
    });

    // login page
    $('.enter-form').find('input:not([type="hidden"])').first().focus();

    
    /**
     * Uploads file visual
     */
    $('[data-load-file]').on('change', function () {
        var filename = $(this).val(),
            $this = $(this).closest('.upload-file-block');
        if (/^\s*$/.test(filename)) {
            $this.removeClass('loaded');
            $this.find(".btn_delete").hide();
            $this.find("input").val('');
            $this.find("label span").text( $this.find("label").attr('data-text'));
            $this.siblings('input').prop('required', 'required');
        }
        else {
            $this.addClass('loaded');
            $this.find(".btn_delete").show();
            $this.find("label span").text(filename.replace("C:\\fakepath\\", ""));
            $this.siblings('input').prop('required', false);
        }
    });

    $(".upload-file-block .btn_delete").on('click', function(e) {
        e.preventDefault();
        var $this = $(this).closest('.upload-file-block');
        $this.removeClass('loaded');
        $this.find(".btn_delete").hide();
        $this.find("input").val('');
        $this.find("label span").text( $this.find("label").attr('data-text'));
        $this.siblings('input').prop('required', 'required');
    });

    $('.show_drop_down').on('click', '.show_toggle', function(){
        let $container = $(this).closest('.show_drop_down');
        if($container.hasClass('open')){
            $container.removeClass('open');
            $container.find('.hidden_drop_down').fadeOut(200);
        } else {
            $container.addClass('open');
            $container.find('.hidden_drop_down').fadeIn(200);
        }
    });
    $(document).on('mouseup', function (e) {
        var container = $(".show_drop_down");
        if (container.has(e.target).length === 0 && !container.is(e.target)) {
            container.removeClass('open');
            container.find('.hidden_drop_down').fadeOut(200);
        }
    });
    

    $('.toggle_link').on('click', function(e){
        e.preventDefault();

        let $content = $(this).closest('.toggle_header').siblings('.control-panel_body');
        $content.slideToggle(200);
        $(this).toggleClass('close');
    });
});
